module.exports = __webpack_public_path__ + "1929650545b2e1e5c3f8c69107c34df0.svg";